module.exports = __webpack_public_path__ + "img/dy07.7b352cc6.png";